/**
 * If length of the string is exceeded the provided maximum length value then
 * truncates string to a requested length and adds ellipsis to the end of the
 * string, otherwise returns string without changing it.
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) {
    return text;
  }

  return text.slice(0, maxLength - 3) + '...';
}

/**
 * Capitalize string literal by converting first letter to upper case.
 */
export function capitalize(text: string): string {
  return text[0].toUpperCase() + text.slice(1);
}

/**
 * Converts a SCREAMING_SNAKE_CASE string to 'Sentence case'.
 * e.g., 'APPLICATION_IN_PROGRESS' becomes 'Application in progress'.
 * Returns an empty string if the input is falsy or not a string.
 */
export function screamingSnakeToSentenceCase(text: string | null | undefined): string {
  if (!text || typeof text !== 'string') {
    return '';
  }
  const formatted = text.replace(/_/g, ' ').toLowerCase();
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

/**
 * Simple string hash function to generate a consistent number.
 * @param value The string to hash.
 * @returns A number that consistently represents the given string.
 */
export function simpleStringHash(value: string): number {
  let hash = 0;

  for (let i = 0; i < value.length; i++) {
    const char = value.charCodeAt(i);
    // Hash formula: hash = hash * 31 + char (implemented with bit shift).
    hash = (hash << 5) - hash + char;
    // Coerce to 32bit integer.
    hash |= 0;
  }

  return Math.abs(hash);
}

/**
 * Converts null, undefined, empty, or "null" strings (case-insensitive) to an empty string.
 * Otherwise returns the trimmed original string.
 */
export function nullToEmpty(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  const trimmed = value.trim();
  if (trimmed === '' || trimmed.toLowerCase() === 'null') {
    return '';
  }

  return trimmed;
}
